<template>
  <d-modal
    class="modal-big"
    @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ popupTitle }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <table
        v-if="type === 'logs'"
        class="table">
        <thead>
          <tr>
            <th>{{ $t('order.warehouse.boxes.popup.table.createdAt') }}</th>
            <th>{{ $t('order.warehouse.boxes.popup.table.user') }}</th>
            <th>{{ $t('order.warehouse.boxes.popup.table.type') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, index) of data"
            :key="'logs-row-' + index">
            <td>{{ row.created_at }}</td>
            <td>{{ row.user_name }}</td>
            <td>{{ $t('order.warehouse.boxes.popup.status.logs.' + row.action) }}</td>
          </tr>
        </tbody>
      </table>

      <table
        v-else-if="type === 'statuses'"
        class="table">
        <thead>
          <tr>
            <th>{{ $t('order.warehouse.boxes.popup.table.createdAt') }}</th>
            <th>{{ $t('order.warehouse.boxes.popup.table.user') }}</th>
            <th>{{ $t('order.warehouse.boxes.popup.table.status') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, index) of data"
            :key="'statuses-row-' + index">
            <td>{{ row.created_at }}</td>
            <td>{{ row.user_name }}</td>
            <td>{{ $t('order.warehouse.boxes.popup.status.statuses.' + row.status) }}</td>
          </tr>
        </tbody>
      </table>

      <table
        v-else-if="type === 'collections'"
        class="table">
        <thead>
          <th>{{ $t('order.warehouse.boxes.popup.table.createdAt') }}</th>
          <th>{{ $t('order.warehouse.boxes.popup.table.user') }}</th>
          <th>{{ $t('order.warehouse.boxes.popup.table.quantity') }}</th>
          <th>{{ $t('order.warehouse.boxes.popup.table.notes') }}</th>
        </thead>
        <tbody>
          <tr
            v-for="(row, index) of data"
            :key="'collections-row-' + index">
            <td>{{ row.created_at }}</td>
            <td>{{ row.user_name }}</td>
            <td>{{ row.quantity }} {{ $t('ui.piecesAbbr') }}</td>
            <td>{{ row.description }}</td>
          </tr>
        </tbody>
      </table>

      <table
        v-else-if="type === 'verifications'"
        class="table">
        <thead>
          <th>{{ $t('order.warehouse.boxes.popup.table.createdAt') }}</th>
          <th>{{ $t('order.warehouse.boxes.popup.table.user') }}</th>
          <th>{{ $t('order.warehouse.boxes.popup.table.status') }}</th>
          <th>{{ $t('order.warehouse.boxes.popup.table.verified') }}</th>
          <th>{{ $t('order.warehouse.boxes.popup.table.notes') }}</th>
        </thead>
        <tbody>
          <tr
            v-for="(row, index) of data"
            :key="'collections-row-' + index">
            <td>{{ row.created_at }}</td>
            <td>{{ row.user_name }}</td>
            <td>{{ $t('order.warehouse.boxes.status.' + row.status.toLowerCase()) }}</td>
            <td>{{ row.verified_quantity }} {{ $t('ui.piecesAbbr') }}</td>
            <td>{{ row.description }}</td>
          </tr>
        </tbody>
      </table>

      <table
        v-else-if="type === 'returns'"
        class="table">
        <thead>
          <th>{{ $t('order.warehouse.boxes.popup.table.createdAt') }}</th>
          <th>{{ $t('order.warehouse.boxes.popup.table.user') }}</th>
          <th>{{ $t('order.warehouse.boxes.popup.table.returned') }}</th>
          <th>{{ $t('order.warehouse.boxes.popup.table.notes') }}</th>
        </thead>
        <tbody>
          <tr
            v-for="(row, index) of data"
            :key="'collections-row-' + index">
            <td>{{ row.created_at }}</td>
            <td>{{ row.user_name }}</td>
            <td>{{ row.returned_quantity }} {{ $t('ui.piecesAbbr') }}</td>
            <td>{{ row.description }}</td>
          </tr>
        </tbody>
      </table>
    </d-modal-body>
  </d-modal>
</template>

<script>
export default {
  name: 'order-collect-boxes-history-popup',
  props: [
    'type',
    'data'
  ],
  computed: {
    popupTitle () {
      return this.$t('order.warehouse.boxes.popup.title.' + this.type);
    }
  },
  methods: {
    handleClose () {
      this.$bus.$emit('close-order-collect-boxes-history-popup');
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
